import { CompanyWorkerSalary, MonthSalariesActions } from "model/Salary";

export type MonthSalaryActions =
  | {
      type: MonthSalariesActions.GetAllSalaries;
      payload: { workersWithSalary: CompanyWorkerSalary[]; total: number };
    }
  | { type: MonthSalariesActions.ClearSalaries; payload: null }
  | { type: "SET_IS_LOADING"; payload: boolean }
  | { type: "SET_REQUEST_ERROR"; payload: MonthSalaryState["error"] };

export type MonthSalaryState = {
  workersWithSalary: CompanyWorkerSalary[];
  isLoading: boolean;
  total: number;
  error: { message: string; err: Error } | null;
};

export const monthSalaryInitState: MonthSalaryState = {
  workersWithSalary: [],
  isLoading: false,
  total: 0,
  error: null,
};

export const monthSalaryStateReducer = (
  state: MonthSalaryState,
  action: MonthSalaryActions,
): MonthSalaryState => {
  switch (action.type) {
    case MonthSalariesActions.GetAllSalaries: {
      return {
        ...state,
        workersWithSalary: action.payload.workersWithSalary,
        total: action.payload.total,
      };
    }
    case MonthSalariesActions.ClearSalaries: {
      return {
        ...state,
        workersWithSalary: [],
        total: 0,
      };
    }
    case "SET_IS_LOADING": {
      return { ...state, isLoading: action.payload };
    }
    case "SET_REQUEST_ERROR": {
      return { ...state, error: action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${(action as any).type}`);
    }
  }
};
